import React from "react";

import { CHANNEL_GROUPS } from "../registrationConfig";
import ArrowRight from "../components/ArrowRight";
import AlreadyHaveAccount from "../components/AlreadyHaveAccount";

/**
 * Step 1 — "Welche Verkaufskanäle nutzt du?"
 * Multi-select channel cards (2-col grid, grouped). ≥1 required to proceed.
 * All channels selectable — no gating/waitlist.
 */
const ChannelSelectionStep = ({ selectedChannels, setSelectedChannels, onNext }) => {
    const toggleChannel = (id) => {
        setSelectedChannels((prev) =>
            prev.includes(id) ? prev.filter((c) => c !== id) : [...prev, id]
        );
    };

    const count = selectedChannels.length;
    const canProceed = count > 0;

    return (
        <div className="registration-step registration-step--channels" data-cy="registration-step-channels">
            <p className="registration-step__eyebrow">Lass uns gemeinsam dein Konto erstellen!</p>
            <h1 className="registration-step__title">Welche Verkaufskanäle nutzt du?</h1>

            {CHANNEL_GROUPS.map((group) => (
                <div key={group.label} className="channel-group">
                    <p className="channel-group__label">{group.label}</p>
                    <div className="channel-group__grid">
                        {group.channels.map((channel) => {
                            const selected = selectedChannels.includes(channel.id);
                            return (
                                <button
                                    key={channel.id}
                                    type="button"
                                    className={`channel-card${selected ? " channel-card--selected" : ""}`}
                                    onClick={() => toggleChannel(channel.id)}
                                    aria-pressed={selected}
                                    data-cy={`registration-channel-${channel.id}`}
                                >
                                    <img
                                        className="channel-card__logo"
                                        src={channel.logo}
                                        alt={`${channel.label} Logo`}
                                    />
                                    <span className="channel-card__label">{channel.label}</span>
                                    {selected && <span className="channel-card__check" aria-hidden />}
                                </button>
                            );
                        })}
                    </div>
                </div>
            ))}

            <button
                type="button"
                className="registration-cta"
                disabled={!canProceed}
                onClick={onNext}
                data-cy="registration-channels-next"
            >
                {canProceed ? `Weiter (${count} ausgewählt)` : "Weiter"} <ArrowRight />
            </button>

            <AlreadyHaveAccount />
        </div>
    );
};

export default ChannelSelectionStep;
